/** @file The models for peer feedback. */
import * as api from '@codegrade/api';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class PeerFeedbackSettings extends api.AssignmentPeerFeedbackSettings {
}
